import { useQuery } from '@tanstack/react-query';
import * as api from '../api/mail.api';

// params: { cursor, limit, unread, flagged, hasAttachments, fromDate, toDate, q, sort }
export const useMessages = (mailboxId, folder, params = {}) => {
  const key = ['mail','messages', mailboxId, folder, JSON.stringify(params)];
  return useQuery({ queryKey: key, queryFn: () => api.mailboxFolderMessages(mailboxId, folder, params), enabled: !!mailboxId && !!folder, keepPreviousData: true });
};
